import { render, staticRenderFns } from "./DeliveryCutoffReport.vue?vue&type=template&id=12939c12&scoped=true"
import script from "./DeliveryCutoffReport.vue?vue&type=script&lang=js"
export * from "./DeliveryCutoffReport.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCutoffReport.vue?vue&type=style&index=0&id=12939c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12939c12",
  null
  
)

export default component.exports